// extracted by mini-css-extract-plugin
module.exports = {"item":"Reviews-module--item--3BU25","user":"Reviews-module--user--BaigG","label":"Reviews-module--label--pNP_S"};